import Nango from '@nangohq/frontend'
import { toastStore } from 'shared/ui'
import { logger } from 'shared/lib'
import { type Integration, IntegrationsApi } from 'entities/Integrations'

export const nangoReconnect = async (integration: Integration) => {
  const nango = new Nango()
  const connect = nango.openConnectUI({
    onEvent: async (event) => {
      if (event.type === 'close') {
        // Handle modal closed.
      } else if (event.type === 'connect') {
        toastStore.add({
          type: 'success',
          title: `${integration.name} reconnected successfully`,
        })
        setTimeout(() => connect.close(), 100)
      }
    },
  })
  try {
    const { data } = await IntegrationsApi.getReconnectData(integration.key)
    connect.setSessionToken(data.data?.token) // A loading indicator is shown until this is set.
  } catch (e) {
    connect.close()
    logger.error(e)
  }
}
